const Form067EN = {
    // form: "Application For Special Pay Arrangement Form",
    form: "Application for Special Pay Arrangement in the {{schoolYear}} School Year for Over-ranked Head / Stepped-down Senior Teacher(s) in Aided Primary Schools",
    errorMsg: {
        "E-0106": "AA000000(A)",
        "E-0105": "Please enter a valid English Name.",
        "E-0104": "Please enter a valid Chinese Name",
        "E-0103": "Please input the range of 29-41",
        "E-0102": "Please input the range of 25-41",
        "E-0101": "Please enter the correct number",
        "E-0100": "Please input the range of 0-49",
        "E-0111": "Please input the range of 0-49",
        "E-0099": "Please input the range of 0-49",
        "E-0107": "Should not be the same rank before/after change",
        schoolYear:
            "Please input a valid proposed school year (20XX/XX) which should not be the current school year or earlier",
        firstSchoolYearError:
            "Please input a valid school year (20XX/XX) which should not be the current or subsequent school years",
        E01: "Cannot be the same rank",
        reason: "Please input a valid reason",
        schoolYearError:
            "Proposed school year should not be a previous school year",
        tooltip10: "The Max Salary should not be smaller than the Salary.",
        mergeYearRequired: "Please select the year of toleration after the commencement of the merger",
        schoolYearFormat: "Please input a valid school year (20XX/YY)",
    },

    stepName: {
        ImportantNotes: "Important Notes",
        action: "Action",
        note: "Note",
        information: "Basic Information ",
        payPointForOverRankedStaff: "Pay Point for Over-Ranked Staff",
        certification: "Certification",
        confirmation: "Confirmation",
    },
    businessTypes: {},
    label: {
        ImportantNotesContent: {
            title: "Personal Information Collection Statement",
            p_title: "Purpose of Collection",
            p1_1: "The personal data provided by you in this form will be used by the EDB for one or more of the following purposes:",
            p1_a: "Activities relating to the processing, authentication and counter-checking of the application for special pay arrangement for over-ranked head/ stepped-down teachers or laboratory technicians in aided schools;",
            p1_b: "Activities relating to matching of the personal data with the database of other relevant Government bureaux / departments in connection with the processing, authentication and counter-checking of the application mentioned in (a) above;",
            p1_c: "Activities relating to matching of the personal data within the database of EDB for purposes of verifying / updating records of the EDB;",
            p1_d: "Activities relating to training and development including invitation of participation in programmes / activities, applications for reimbursement of course fees, assessment of nominations, awards and scholarship, and monitoring of attainment progress;",
            p1_e: "Activities relating to the processing and vetting of applications for, and disbursement of, funding / grants / subsidies, and conducting of audits;",
            p1_f: "Activities relating to compilation of statistics, research and Government publications; and",
            p1_g: "Activities relating to the administration and enforcement of rules and regulations including the Education Ordinance (Cap. 279), its subsidiary legislation (such as the Education Regulations and the Grant/Subsidized Schools Provident Fund Rules) and the Codes of Aid.",

            p2: "The provision of personal data required by this form and during the processing of this form is obligatory.  In the event that you do not provide those personal data, we may not be able to handle or further process the application.",

            p_title3: "Classes of Transferees",
            p3_1: "The personal data you provide will be made available to persons working in EDB.  Apart from this, they may be transferred or disclosed to the parties or in the circumstances listed below:-",
            p3_a: "other Government bureau and departments for the purposes mentioned in paragraph 1 above;",
            p3_b: "the school in which the form relates for the purposes mentioned in paragraph 1 above;",
            p3_c: "where you have given your prescribed consent to such disclosure; and",
            p3_d: "where such disclosure is authorised or required under the law or court order applicable to Hong Kong.",

            p_title4: "Access to Personal Data",
            p4: "You have the right to request access to and correction of your personal data held by EDB.  Request for access or correction of personal data should be made in writing to the respective Senior School Development Officer by post to the Regional Education Office at the address on the EDB website (<a href='https://www.edb.gov.hk/tc/contact-us/reo.html' target='_blank'>https://www.edb.gov.hk/en/contact-us/reo.html</a>) or email to <a href='mailto: edbinfo@edb.gov.hk'>edbinfo@edb.gov.hk</a>.",
            // p5: "如欲查詢有關本表格所蒐集的個人資料，包括要求查閱及改正資料事宜，需以書面方式向教育局提出。",
        },
        certify: "I confirm that:",
        ImportantNotes: "ImportantNotes",
        csdoBeforeText: "To : CSDO (",
        // csdoBeforeText: "To : (",
        csdoBeforeTextTemp: "To : ",

        csdoAfterText: "), Education Bureau",
        csdoAfterTextTemp: ", Education Bureau",
        applicationForm: "Application Form",
        confirmation: "Confirmation Statement",
        note: "Note",
        schoolChoice: {
            ManagementCommittee: "School Management Committee",
            Incorporated: "Incorporated Management Committee",
        },
        day: {
            1: "1",
            2: "2",
            3: "3",
            4: "4",
            5: "5",
            6: "6",
            7: "7",
            8: "8",
            9: "9",
            10: "10",
            11: "11",
            12: "12",
            13: "13",
            14: "14",
            15: "15",
            16: "16",
            17: "17",
            18: "18",
            19: "19",
            20: "20",
            21: "21",
            22: "22",
            23: "23",
            24: "24",
            25: "25",
            26: "26",
            27: "27",
            28: "28",
            29: "29",
            30: "30",
            31: "31",
        },
        month: {
            august: "August",
            september: "September",
        },
        hisHerTheir: {
            his: "his",
            her: "her",
            their: "their",
        },
        specify: "Please specify",

        ActionToBeTakenList: {
            one: "Redeploy the over-ranked staff to fill a vacancy due to retirement / resignation / end of contract of a staff in the same school.",
            two: "Redeploy the over-ranked staff to fill a new post of the corresponding rank to be created in the same  school due to <u>{{desc}}</u>.",
            three: "Redeploy the over-ranked staff to fill a vacancy due to retirement / resignation / end of contract of a staff in another school under the same sponsoring body.",
            four: "Redeploy the over-ranked staff to fill a new post of the corresponding rank to be created in another school under the same sponsoring body due to <u>{{desc}}</u>.",
            five: "The over-ranked staff will join job-sharing.",
            six: "The over-ranked staff will retire/resign.",
            seven: "The school will continue operating P1 classes after the merger and is under the <u>{{sevenMergeYear}}</u> year of toleration after the commencement of the merger.  It is allowed to retain, for three years, the incumbent teachers on the approved teaching staff establishment related to the levels under merger of the schools involved in merger in the school year preceding the merger.  The school will rectify the over-ranked situation after the completion of the 3-year toleration period, i.e. <u>{{sevenSchoolYear}}</u> school year.",
            eight: "Other action: <u>{{desc}}</u>.",
            nine: "Other action: <u>{{desc}}</u>.",
            ten: "Other action: <u>{{desc}}</u>.",
        },
        ActionToBeTakenListTemp: {
            one: "Redeploy the over-ranked staff to fill a vacancy due to retirement / resignation / end of contract of a staff in the same school.",
            two: "Redeploy the over-ranked staff to fill a new post of the corresponding rank to be created in the same  school due to___________.",
            three: "Redeploy the over-ranked staff to fill a vacancy due to retirement / resignation / end of contract of a staff in another school under the same sponsoring body.",
            four: "Redeploy the over-ranked staff to fill a new post of the corresponding rank to be created in another school under the same sponsoring body due to___________.",
            five: "The over-ranked staff will join job-sharing.",
            six: "The over-ranked staff will retire/resign.",
            seven: "The school will continue operating P1 classes after the merger and is under the___________year of toleration after the commencement of the merger.  It is allowed to retain, for three years, the incumbent teachers on the approved teaching staff establishment related to the levels under merger of the schools involved in merger in the school year preceding the merger.  The school will rectify the over-ranked situation after the completion of the 3-year toleration period, i.e. 20__/__ school year.",
            eight: "Other action: <u>{{desc}}</u>",
            nine: "Other action: <u>{{desc}}</u>",
            ten: "Other action: <u>{{desc}}</u>",
        },
        mergeYearOption: {
            one:   "1st",
            two:   "2nd",
            three: "3rd",
        },

        ActionToBeTakenSeven: {
            part1: "The school will continue operating P1 classes after the merger and is under the",
            part2: "year of toleration after the commencement of the merger.  It is allowed to retain, for three years, the incumbent teachers on the approved teaching staff establishment related to the levels under merger of the schools involved in merger in the school year preceding the merger.  The school will rectify the over-ranked situation after the completion of the 3-year toleration period, i.e. ",
            part3: " school year.",
        },
        ActionToBeTakenList2: { ten: "NA" },
        IncrementalDateList: {
            0: " ",
            1: "01",
            2: "02",
            3: "03",
            4: "04",
            5: "05",
            6: "06",
            7: "07",
            8: "08",
            9: "09",
            10: "10",
            11: "11",
            12: "12",
        },
        CSDOTypes: {
            // NORTH: "NORTH District",
            // KWAITSING: "KWAI TSING District",
            // SAIKUNG: "SAI KUNG District",
            // EASTERN: "EASTERN District",
            // TUENMUN: "TUEN MUN District",
            // KOWLOONCITY: "KOWLOON CITY District",
            // KWUNTONG: "KWUN TONG District",
            // SOUTHERN: "SOUTHERN District",
            // YAUTSIMMONG: "YAU TSIM MONG District",
            // TSUENWAN: "TSUEN WAN District",
            // SHATIN: "SHA TIN District",
            // SHAMSHUIPO: "SHAM SHUI PO District",
            // TAIPO: "TAI PO District",
            // WANCHAI: "WAN CHAI District",
            // ISLANDS: "ISLANDS District",
            // CENTRALANDWESTERN: "CENTRAL AND WESTERN District",
            // YUENLONG: "YUEN LONG District",
            // WONGTAISIN: "WONG TAI SIN District",
            Central_and_Western: "Central & Western District",
            Southern: "Southern District",
            Wan_Chai: "Wan Chai District",
            Islands: "Islands District",
            HKEast: "Hong Kong East District",
            Kowloon_City: "Kowloon City District",
            Sham_Shui_Po: "Sham Shui Po District",
            Sai_Kung: "Sai Kung District",
            Kwun_Tong: "Kwun Tong District",
            Wong_Tai_Sin: "Wong Tai Sin District",
            Yau_Tsim_Mong: "Yau Tsim & Mong Kok District",
            Tai_Po: "Tai Po District",
            North: "North District",
            Sha_Tin: "Sha Tin District",
            Kwai_Chung_and_Tsing_Yi: "Kwai Chung & Tsing Yi District",
            Tsuen_Wan: "Tsuen Wan District",
            Tuen_Mun: "Tuen Mun District",
            Yuen_Long: "Yuen Long District",
        },
        conditions:
            "I have read and understood the “Personal Information Collection Statement”.",
        iamSignCheck:
            "I understood that digital signature through “iAM Smart+” is required on this fillable form for e-submission.",
        noteList: {
            noteOne:
                "PLEASE READ THE FOLLOWING TERMS AND CONDITIONS BEFORE USING THIS WEBSITE. BY USING THIS WEBSITE YOU AGREE TO ABIDE BY THE TERMS AND CONDITIONS SET OUT BELOW.",
            noteTwo:
                "Please submit either e-form or paper, if duplicate application has been submitted, the process would be decelerated.",
            noteThree:
                "Enquiries concerning the personal data collected by means of this form, including making of access and corrections, should be made in writing to the respective Senior School Development Officer.",
            note1: "1 : Please delete as appropriate.",
            note2: "2 : The stepped-down staff with pay point not reaching the maximum pay point of thestepped-down rank is allowed to proceed along the salary scale of the stepped-down rank.",
            note3: "3 : Excluding the Responsibility Allowance, if any.",
            note4:
                "4 : For stepping down that involves a teacher at more than one rank above the basic rank (e.g. PGM) and where no vacancy is available at the next lower rank, the school concerned is given the discretion to decide whether to have" +
                "the teacher step down more than one rank or to have a series of step-downs involving more than one teacher until " +
                "the entitlement is not exceeded. The decision made should be supported with strong justifications. An appeal " +
                "mechanism should also be in place. All these should be made known to the teachers of the school and be properly" +
                "documented as a safeguard against any allegations of unfairness or impropriety that may subsequently arise.",
            note5: "5 : No longer eligible for any Responsibility Allowance previously entitled to, if any, which thus should be excluded.",
            note6: "6 : Only applicable to the stepped-down staff with pay point not yet exceeding the maximum pay point of the stepped-down rank.",
            note7: "7 : Please refer to the attached Annex and fill in the Code Number.",
            note8: "8 : If the proposed school year is not the 2021/22 school year, the school should also attach a plan on how to rectify the situation and list out the anticipated vacancy situation of promotion ranks among schools under the same sponsoring body (if applicable) in the coming school years.",

            // note0: "I confirm that:",
            // notea: "(a) the selection arrangement of surplus staff stipulated in EDBCM No. 46/2020 has been observed;",
            // noteb:
            //     "(b) there are no vacancies of the relevant ranks within the school or in schools under the same" +
            //     "sponsoring body for redeployment in the 2020/21 school year. The vacancy situation of respective" +
            //     "promotion ranks within the school and among schools under the same sponsoring body (if  " +
            //     "applicable) is attached;",
            // notec: "(c) the stepped-down staff were informed of the above special and temporary arrangement;",
            // noted: "(d) the particulars in this form including the Rectification Plan are correct;",
            // notee: "(e) duties of the stepped-down staff will be commensurate with his/her/their salary as far as possible in the 2020/21 school year; and",
            // notef: "(f) the School shall refund to the Education Bureau any over-payment of the salaries grant paid to it.",
            // notef: "Actions suggested in Code Numbers 1 to 6 are for school's reference and are not exhaustive. Please specify in Code Numbers 7 to 9 any other proposed effective measures to rectify the over-ranked situation.",
            notef: "Please refer to the attached Annex and fill in the Code Number.",

            ImportantNotes: "Personal Information Collection Statement",
            title: "The personal data provided in this form will be used by the Education Bureau for one or more of the following purpose(s):",
            a: "processing employment-related matters;",
            b: "processing Salaries Grant payment and calculation of provident fund contribution and donation;",
            c: "auditing;",
            d: "conducting research and compiling statistics to facilitate planning of education services;",
            e: "processing matters relating to the development of the education profession;",
            f: "administering and enforcing the Education Ordinance and Regulations and the Grant/Subsidized Schools Provident Fund Rules (Cap. 279).",
            title1: "The provision of personal data by means of this form is obligatory.  Failure to provide these data may affect the processing and outcome of your application.",
            title2: "The personal data collected in this form may be disclosed to other government bureau/departments/agencies authorized to process such information for the purposes mentioned above.",
            title3: "You have a right to request access to and correction of your personal data as provided in Sections 18 and 22 and Data Protection Principle 6 of Schedule 1 of the Personal Data (Privacy) Ordinance.  Your right of access includes the right to obtain a copy of your personal data provided in this form.  This is however subject to payment of a fee.",
            title4: "Enquiries concerning the personal data collected by means of this form, including making of access and corrections, should be made in writing to Education Bureau.",
            // title4: "",

            cera: "{{circularNumber}};",
            cerb: "the stepped-down staff were informed of the above ",
            cerb1: "special and temporary ",
            cerb2: "arrangement;",
            cerc: "the particulars in this form including the Rectification Plan are correct;",
            cerd: "the duties of the stepped-down staff will be commensurate with his/her/their salary as far as possible in the {{schoolYear}} school year; and",
            cere: "the School shall refund any overpaid salaries grant to the Education Bureau.",
        },
        rankList: {
            // AM: "AM",
            // SAM: "SAM",
            // PAM: "PAM",
            // PSM: "PSM",
            // SPSM: "SPSM",
            // HMI: "HMI",
            // HMII: "HMII",

            // LTI: "LTI",
            // AM: "AM",
            // SAM: "SAM",
            // PAM: "PAM",
            // SGM: "SGM",
            // PGM: "PGM",
            // PII: "PII",
            // PI: "PI",

            CM: "CM",
            APSM: "APSM",
            AM: "AM",
            SAM: "SAM",
            PAM: "PAM",
            PSM: "PSM",
            SPSM: "SPSM",
            HMII: "HMII",
            HMI: "HMI",
        },
        // rectificationPlan: "Plan to Rectify the Over-ranked Situation",
        rectificationPlan: "Rectification Plan",
    },
    note: {
        note1: "The personal data provided in this form will be used by the Education Bureau for one or more of the following purpose(s):",
        a: "processing employment-related matters;",
        b: "processing payment of Salaries Grant and other government funding;",
        c: "calculation of provident fund contribution;",
        d: "auditing;",
        e: "conducting research and compiling statistics to facilitate planning of education services;",
        f: "processing matters relating to the development of the education profession;",
        g: "administering and enforcing stipulations under the relevant Code of Aid, Education Ordinance, Education Regulations and the Grant/Subsidized Schools Provident Fund Rules.",
        note22: "The provision of personal data by means of this form is obligatory.  Failure to provide these data may affect the processing and outcome of your application.",
        note23: "The personal data collected in this form may be disclosed to other government bureaux/departments/agencies authorized to process such information for the purposes mentioned above.",
        note24: "You have a right to request access to and correction of your personal data as provided in Sections 18 and 22 and Data Protection Principle 6 of Schedule 1 of the Personal Data (Privacy) Ordinance.  Your right of access includes the right to obtain a copy of your personal data provided in this form.  This is however subject to payment of a fee.",
        note25: "Enquiries concerning the personal data collected by means of this form, including making of access and corrections, should be made in writing to the respective Senior School Development Officer.",
    },
    information: {
        csdo: "CSDO",
        date: "Date",
        managementCommittee:
            "The School Management Committee/Incorporated Management Committee:",
        formHeaderTitle: "Staff {{index}}",
        code: "code",
        record: {
            1: "1",
            2: "2",
            3: "3",
        },
        hkidNo: "HKID No.",
        englishName: "English Name",
        chineseName: "Chinese Name",
        firstSchoolYear:
            "For staff who stepped down on or before 31 August {{year}}, fill in the school year of the approval of the <u><b>1<sup>st</sup> application</b> of special pay arrangement</u>",
        pleaseSpecify: "please Specify",
        ranks: "Rank",
        salary: "Salary (MPS Pt)",
        salaryBar: "Salary Bar (MPS Pt)",
        maxSalary: "Max Salary (MPS Pt)",
        incrementalDate: "Incremental Date (01/mm)",
        effectiveDateFrom: "Effective Date from",
        effectiveDateTo: "Effective Date to",

        rank: "Rank",
        salarys: "Salary (MPS Pt)",
        salaryBars: "Salary Bar (MPS Pt)",
        maxSalarys: "Max Salary (MPS Pt)",
        // incrementalDates: "Incremental Date(01/mm)",
        dateOfNextIncrement: "Date of Next Increment",
        // actionToBeTaken:
        //     "Action To be Taken in the {{schoolYearNext}} School Year and the Years Afterwards",
        actionToBeTaken: "Action to be taken",
        proposedSchoolYear: "Proposed School Year",

        Notes1: "As at 31 August {{year}} ",
        EffectiveDateFromBeforeText: "From",
        EffectiveDateFromAfterText: "to",
        EffectiveDateToAfterText:
            "upon Stepping Down (Please Amend the Period if Necessary).",
        Notes2: "From {{from}} to {{to}} ",
        Notes2Temp: "Effective upon Stepping Down",
        Note: {
            Note1: "Please delete as appropriate.",
            Note2: "The stepped-down staff with pay point not reaching the maximum pay point of the stepped-down rank is allowed to proceed along the salary scale of the stepped-down rank.",
            Note3: "Excluding the Responsibility Allowance, if any. ",
            Note4: "For stepping down that involves a senior teacher at <u>more than one rank</u> above the basic rank (e.g. SPSM) and where no vacancy is available at the next lower rank, the school concerned is given the discretion to decide whether to have the senior teacher step down more than one rank or to have a series of step-downs involving more than one senior teacher until the entitlement is not exceeded. The decision made should be supported with strong justifications. An appeal mechanism should also be in place. All these should be made known to the teachers of the school and be properly documented as a safeguard against any allegations of unfairness or impropriety that may subsequently arise.",
            Note5: "No longer eligible for any Responsibility Allowance previously entitled to, if any, which thus should be excluded.",
            Note6: 'Only applicable to the stepped-down staff with pay point not yet exceeding the maximum pay point of the stepped-down rank.  For all other cases, please indicate "NA". The stepped-down staff will not be granted any salary increment until he/she is reinstated to the previous rank at your school for normal progression along the salary scale of the previous rank.',
            Note7: "Please refer to the attached Annex and fill in the Code Number.",
        },

        beforeDateText: "I refer to your letter dated",
        // afterDateText: " August/September 2020. ",
        afterDateText: ". The",
        management:
            "The School Management Committee/Incorporated Management Committee",
        beforeNote1Text:
            "  would like to seek approval for the following over-ranked staff (including those over-ranked head and/or stepped-down senior teacher(s) who stepped down prior to 1 September {{year}}) to retain,in the {{schoolYear}} school year, ",
        afterNote1Text: "pay point(s) as at",
        noteLabel1: " his/her/their ",
        noteLabel2: " 31 August {{year}}",
        afterNote2Text: " as detailed below -",
        attachment: "Supplementary document",
        lastSchoolEmployment: "Last school of employment",
        primaryOrSecondaryOption: {
            primary: "Primary School",
            secondary: "Seconday School",
        },
    },
    SalaryList: {
        // 0: "12,915",
        // 1: "13,735",
        // 2: "14,600",
        // 3: "15,560",
        // 4: "16,565",
        // 5: "17,675",
        // 6: "18,795",
        // 7: "20,035",
        // 8: "21,340",
        // 9: "22,725",
        // 10: "24,070",
        // 11: "25,545",
        // 12: "27,145",
        // 13: "28,780",
        // 14: "30,235",
        // 15: "31,750",
        // 16: "33,350",
        // 17: "35,040",
        // 18: "36,765",
        // 19: "38,595",
        // 20: "40,515",
        // 21: "42,545",
        // 22: "44,555",
        // 23: "46,655",
        // 24: "48,860",
        25: "51,095",
        26: "53,500",
        27: "55,995",
        28: "58,635",
        29: "61,415",
        30: "64,270",
        31: "67,295",
        32: "70,465",
        33: "73,775",
        34: "74,515",
        35: "75,265",
        36: "78,385",
        37: "82,105",
        38: "85,870",
        39: "89,845",
        40: "93,710",
        41: "97,745",
        // 42: "101,965",
        // 43: "106,340",
        // 44: "110,170",
        // 45: "117,580",
        // 46: "121,790",
        // 47: "126,220",
        // 48: "130,760",
        // 49: "135,470",
    },
    tooltipList: {
        tooltip1: "Please delete as appropriate.",
        tooltip2:
            "The stepped-down staff with pay point not reaching the maximum pay point of the stepped-down rank is allowed to proceed along the salary scale of the stepped-down rank.",
        tooltip3:
            "Only applicable to the stepped-down staff who has been approved for special pay arrangement before.  Please indicate “NA” for staff who has stepped down with effect from 1 September {{year}} and submits the first application for special pay arrangement in the {{schoolyear}} school year.",
        tooltip4: "Excluding the Responsibility Allowance, if any.	",
        tooltip5:
            " For stepping down that involves a senior teacher at more than one rank above the basic rank (e.g. SPSM) and where no vacancy is available at the next lower rank, the school concerned is given the discretion to decide whether to have the senior teacher step down more than one rank or to have a series of step-downs involving more than one senior teacher until the entitlement is not exceeded.  The decision made should be supported with strong justifications.  An appeal mechanism should also be in place.  All these should be made known to the teachers of the school and be properly documented as a safeguard against any allegations of unfairness or impropriety that may subsequently arise.",
        tooltip6:
            "No longer eligible for any Responsibility Allowance previously entitled to, if any, which thus should be excluded.",
        tooltip7:
            'Only applicable to the stepped-down staff with pay point not yet exceeding the maximum pay point of the stepped-down rank.  For all other cases, please indicate "NA". The stepped-down staff will not be granted any salary increment until he/she is <b>reinstated to the previous rank at your school</b> for normal progression along the salary scale of the previous rank.',
        tooltip8:
            "Please refer to the attached Annex and fill in the Code Number.",
    },
};
export default Form067EN;
